package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * Server-created activity notification stored under `users/{uid}/notifications/{id}`.
 *
 * [title]/[preview]/[photoUrl] are display snapshots the Functions stamp at write time (sender or
 * business name, first lines of the message/comment/reply, business logo). All three are optional —
 * docs written before the enrichment shipped lack them, and the UI falls back to a generic
 * per-[type] label with an icon avatar.
 */
data class AppNotification(
    val id: String,
    val type: NotificationType,
    val conversationId: String? = null,
    val businessId: String? = null,
    val reviewId: String? = null,
    val postId: String? = null,
    val orderId: String? = null,
    val eventId: String? = null,
    /** Raw order status ("confirmed"/"fulfilled"/"cancelled") for [NotificationType.Order] rows. */
    val orderStatus: String? = null,
    /** Who/what this is about — sender display name, business name, or event title. */
    val title: String? = null,
    /** First ~180 chars of the message/comment/reply body (already truncated server-side). */
    val preview: String? = null,
    /** Avatar image for the row (e.g. the business logo when a business wrote to the user). */
    val photoUrl: String? = null,
    /**
     * Campaign deep link — a full app universal-link URL (`https://mahaleh.ca/{b|item|post|event}/{id}`).
     * Tapping the row hands it to the App-Links parser, so campaigns can target any surface.
     */
    val link: String? = null,
    /** Which Hidden Gems surface a [NotificationType.Gem] row opens: joke/fact/recipe/tale. */
    val gemKind: String? = null,
    /** The gem's document id — only recipes and tales have a detail screen to open. */
    val gemId: String? = null,
    val read: Boolean = false,
    val createdAtMillis: Long? = null,
)

enum class NotificationType { Message, ReviewReply, Comment, Order, Event, Campaign, Channel, Gem, Other }
